const getName = (context, object) => {
  context.commit("DASHBOARD_NAME_UPDATED", object.name);
};

const setActiveNoteCollapsePanels = (context, arrayOfActivePanels) => {
  localStorage.setItem("customer-dashboard-note-active-collapse-panels", JSON.stringify(arrayOfActivePanels));
  context.commit("SET_ACTIVE_NOTE_COLLAPSE_PANELS", arrayOfActivePanels);
};

const initialiseStore = (context) => {
  context.commit("INITIALISE_STORE");
};

export default {
  getName,
  setActiveNoteCollapsePanels,
  initialiseStore,
};
